import React from 'react';
import { MessageCircle } from 'lucide-react';
import api from '../lib/api';

/**
 * Floating "Chat on WhatsApp" button visible site-wide.
 * Opens a wa.me deep link to the founder's business number (07448 574 616
 * → +447448574616) with a friendly prefilled greeting.
 *
 * Click is tracked into the site-events collection so the founder admin
 * dashboard can see how many leads choose to reach out via WhatsApp.
 */
const WHATSAPP_NUMBER = '447448574616';
const PREFILL = "Hi! I'd like to know more about MyBusinessAdPro.";

const WhatsAppFab = ({ label = 'Chat on WhatsApp' }) => {
  const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(PREFILL)}`;

  const handleClick = () => {
    try {
      api.post('/track/event', {
        type: 'cta_click',
        label: 'whatsapp_fab',
        path: typeof window !== 'undefined' ? window.location.pathname : '',
      });
    } catch {
      /* best-effort */
    }
  };

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      aria-label={label}
      data-testid="whatsapp-fab"
      className="fixed bottom-5 right-5 z-40 group flex items-center gap-2 pl-3 pr-4 h-12 bg-[#25D366] hover:bg-[#1ebe5a] text-white font-semibold rounded-full shadow-lg hover:shadow-xl transition-all"
    >
      <span className="w-9 h-9 -ml-1 rounded-full bg-white/15 flex items-center justify-center">
        <MessageCircle className="w-5 h-5" strokeWidth={2.5} />
      </span>
      <span className="text-sm hidden sm:inline">{label}</span>
    </a>
  );
};

export default WhatsAppFab;
